

































import { defineComponent, computed, ref } from '@vue/composition-api';
import { useI18n } from '~/composables';
import SalesforceWebform from '~/components/organisms/SalesforceWebform/SalesforceWebform.vue';
import { hasManualTranslationsAlways } from '~/helpers/hasManualTranslationsAlways';
import { LinkType } from '~/types/components/Link/LinkType';
import Button from '~/components/atoms/Buttons/Button/Button.vue';
import isStringTrue from '~/helpers/dataStructure/isStringTrue';

export default defineComponent({
  components: {
    SalesforceWebform,
    Button,
  },
  props: {
    manual: {
      type: String,
      required: true,
    },
    sku: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { countryCode } = useI18n();
    const shouldShowRequestTranslationText =
      computed(() =>
        isStringTrue(process.env.salesforceWebformActive) &&
        (!props.manual || !hasManualTranslationsAlways(countryCode.value)),
      );
    const isContactFormVisible = ref(false);
    const toggleContactFormVisibility = () => {
      isContactFormVisible.value = !isContactFormVisible.value;
    };

    return {
      shouldShowRequestTranslationText,
      toggleContactFormVisibility,
      isContactFormVisible,
      LinkType,
    };
  },
});
